import React from "react";
import { useTranslation } from "react-i18next";

export default function DeckPreview({ apiData }) {
  const { t } = useTranslation();

  if (!apiData) {
    return (
      <div className="text-center text-gray-500 py-8">
        <p>No deck data available for preview</p>
      </div>
    );
  }

  let { informationalResponse, warningResponse, errorResponse } = apiData;
  // let { informationalResponse, warningResponse, errorResponse, combinedResponse } = apiData;

// Fix empty errors/warnings in combinedResponse
// if (combinedResponse) {
//     combinedResponse = combinedResponse
//       // Remove "Informational response:" line
//       .replace(/^Informational response:.*\n?/m, "")
//       // Add N/A if errors or warnings are empty
//       .replace(/(Found following errors:)\s*$/m, "$1 N/A")
//       .replace(/(Found following warnings:)\s*$/m, "$1 N/A");
//   }
  
  function formatCombinedResponse(text) {
    return text.split("\n").map((line, index) => {
      const match = line.match(/^([\w\s#]+:)\s*(.*)$/);
      if (match) {
        return (
          <div key={index}>
            <strong>{match[1]}</strong> {match[2]}
          </div>
        );
      }
      return <div key={index}>{line}</div>;
    });
  }
  

  return (
    <div className="space-y-4">
      {/* Errors */}
      {errorResponse && (
        <div className="bg-red-50 border border-red-200 rounded-2xl p-4">
          <h3 className="font-semibold  mb-2 border-b border-red-200 pb-2">{t('DeckErrors')}</h3>
          <div className="text-sm  whitespace-pre-line">
            {formatCombinedResponse(errorResponse)}
          </div>    
        </div>
      )}

      {/* Warnings */}
      {warningResponse && (
        <div className="bg-yellow-50 border border-yellow-200 rounded-2xl p-4">
          <h3 className="font-semibold  mb-2 border-b border-yellow-200 pb-2">{t('DeckWarnings')}</h3>
          <div className="text-sm  whitespace-pre-line">
            {formatCombinedResponse(warningResponse)}
          </div>
        </div>
      )}

      {/* Deck Information */}
      {informationalResponse && (
        <div className="bg-green-50 border border-green-200 rounded-2xl p-4">
          <h3 className="font-semibold  mb-2 border-b border-green-200 pb-2">{t('DeckInformation')}</h3>
          <div className="text-sm  whitespace-pre-line">
            {formatCombinedResponse(informationalResponse)}
          </div>
        </div>
      )}
    </div>
  );
}
                                                   